import React, { createContext } from 'react';
import { usePersistedState } from '~/lib/hooks';
import { IntlProvider } from 'react-intl';
import locale_en from '~/translations/en.json';
import locale_nb from '~/translations/nb.json';
import locale_nn from '~/translations/nn.json';

const data = {
  nb: locale_nb,
  en: locale_en,
  nn: locale_nn,
};
export type supportedLanguages = 'en' | 'nb' | 'nn';
type LanguageContextProps = {
  language: supportedLanguages;
  setLanguage: any;
};

export const LanguageContext = createContext<LanguageContextProps>({
  language: 'nb',
  setLanguage: () => {},
});

// Context is automatically applied to all pages with gatsby-plugin-layout
// See gatsby-config.js
const LanguageContextProvider = (props) => {
  const [language, setLanguage] = usePersistedState<supportedLanguages>(
    'language',
    'nb'
  );
  const contextValue = React.useMemo(
    () => ({ language, setLanguage }),
    [language, setLanguage]
  );

  return (
    <LanguageContext.Provider value={contextValue} {...props}>
      <IntlProvider locale={language} messages={data[language]}>
        {props.children}
      </IntlProvider>
    </LanguageContext.Provider>
  );
};

export function getLanguageName(language: supportedLanguages) {
  if (language === 'en') {
    return 'English';
  } else if (language === 'nb') {
    return 'Bokmål';
  } else if (language === 'nn') {
    return 'Nynorsk';
  }
}

export default LanguageContextProvider;
